import React from 'react';

import { Shield, Search, Filter, AlertTriangle, AlertOctagon, AlertCircle, ChevronRight, ArrowUpDown } from 'lucide-react';

import { Badge } from '../../ui/Badge';
import {Link} from 'react-router-dom'



interface AssetRecentFindingsProps {
  findings: any;
}
const getSeverityIcon = (severity: string) => {
  switch (severity) {
    case 'critical':
      return <AlertOctagon className="h-5 w-5 text-red-500" />;
    case 'high':
      return <AlertTriangle className="h-5 w-5 text-orange-500" />;
    case 'medium':
      return <AlertCircle className="h-5 w-5 text-yellow-500" />;
    case 'low':
      return <Shield className="h-5 w-5 text-emerald-500" />;
    default:
      return <AlertCircle className="h-5 w-5 text-gray-500" />;
  }
};

export const AssetRecentFindings: React.FC<AssetRecentFindingsProps> = ({ findings }) => {
  return (
    <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Shield className="h-5 w-5 text-blue-500" />
          <h2 className="text-lg font-semibold text-white">Recent Findings</h2>
        </div>
        <span className="text-sm text-gray-400">{Array.isArray(findings) ? findings.length : 0} findings</span>
      </div>
      
      <div className="space-y-4">
        {Array.isArray(findings) && findings.length > 0 ? findings.map((finding) => (
          <div
            key={finding.id}
            className="p-4 bg-gray-800/30 rounded-lg group hover:bg-gray-800/50"
          >
            <div className="flex items-start justify-between">
              <div className="space-y-1">
                <div className="flex items-center space-x-3">
                  <div className="p-1.5 rounded-lg bg-gray-800/30">
                    {getSeverityIcon(finding.severity)}
                  </div>
                  <div className="flex items-center space-x-2">
                    <Badge variant={finding.severity as any}>{finding.severity.toUpperCase()}</Badge>
                    <Badge variant={finding.status}>{finding.status.replace('_', ' ').toUpperCase()}</Badge>
                    </div>
                </div>
                <div className="text-sm font-medium text-white">{finding.title}</div>
                <div className="text-sm text-gray-400">{finding.overview}</div>
                <div className="text-xs text-gray-500">
                  Discovered: {new Date(finding.createdAt).toLocaleString()}
                </div>
              </div>
              <button className="p-1.5 rounded-lg hover:bg-gray-800/50 text-gray-400 hover:text-white transition-colors opacity-0 group-hover:opacity-100">
              <Link
                      to={`/findings/${finding.id}`}
                      className="bg-[#1A1F2E] text-white"
                    >     
                <ChevronRight className="h-4 w-4" />
                </Link>
              </button>
            </div>
          </div>
        )) : <div className="text-sm text-gray-400 text-center py-4">No findings available</div>}
      </div>
    </div>
  );
};